import React, { useEffect, useContext, useState, useLayoutEffect } from 'react'
import { getLayoutThemeUrl, getCurrentTheme } from '../../utils/theme'
import FullScreenLoader from '../../components/StructureComponents/UI/FullScreenLoader'
import { GlobalProvider, GlobalContext } from '../../context/GlobalState'
import Modal from 'react-modal'
import loadable from '@loadable/component'
import { customSubmitFunction } from '../../templates/Ebook'
import { useStaticQuery, graphql } from 'gatsby'
import _ from 'lodash'
import { useLocation } from '@reach/router'


export default function PageLayout({ children }) {
  return (
    <>
      <GlobalProvider>
        <LayoutWithoutContext>{children}</LayoutWithoutContext>
      </GlobalProvider>
    </>
  )
}

const LayoutWithoutContext = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const location = useLocation()
  const path = location.pathname
  const hidePopupOnPaths = ['/join-waitlist/', '/early-access/', '/ebooks/become-the-goat-of-productivity/']
  const shouldHidePopup = hidePopupOnPaths.includes(path)


  // Fetch ebook data using staticQuery
  const data = useStaticQuery(graphql`
    query EbookFormatsQuery {
      allMarkdownRemark(
        filter: { frontmatter: { template: { eq: "Ebook" } } }
      ) {
        nodes {
          frontmatter {
            slug
            heroSection {
              featuredImage {
                image
              }
              formats {
                ebook
                pdf
                slideshow
              }
            }
          }
        }
      }
    }
  `)

  const ebookData = data.allMarkdownRemark.nodes[0]?.frontmatter || {}
  const formats = ebookData.heroSection?.formats || {}

  const ContactForm = loadable(() =>
    import('../../components/PageComponents/ContactForm/ContactForm')
  )

  useEffect(() => {
    const layoutTheme = getLayoutThemeUrl()

    if (layoutTheme) {
      let link = document.createElement('link')
      let head = document.getElementsByTagName('head')[0]
      link.rel = 'stylesheet'
      link.type = 'text/css'
      link.rel = 'stylesheet'
      link.href = `/themes/${layoutTheme}/styles/main.css?v=03.9.2021`
      head.appendChild(link)

      link.onload = function () {
        setLoading(false)
        document.getElementById('___gatsby').classList.add('show')
      }
      setTimeout(() => {
        setLoading(false)
        document.getElementById('___gatsby').classList.add('show')
      }, 9500)
    }
  }, [])

  const handleSetScroll = () => {
    localStorage.setItem('scrollpos', window.scrollY)
  }
  useLayoutEffect(() => {
    if (
      typeof window !== 'undefined' &&
      typeof document !== 'undefined' &&
      typeof localStorage !== 'undefined'
    ) {
      document.documentElement.style.scrollBehavior = 'auto'
      // setTimeout(() => {
      //   let scrollpos = localStorage.getItem('scrollpos')
      //   if (scrollpos) window.scrollTo(0, scrollpos)
      //   localStorage.removeItem('scrollpos')
      //   setHideLayout(false)
      //   document.documentElement.style.scrollBehavior = 'smooth'
      // }, 500)

      window.addEventListener('scroll', handleSetScroll)

      return () => {
        window.removeEventListener('scroll', handleSetScroll)
      }
    }
  }, [])

  const { isChangingTheme, setIsChaningTheme } = useContext(GlobalContext)

  useEffect(() => {
    setIsChaningTheme(loading)
  }, [loading])

  const [hasSeenPopup, setHasSeenPopup] = useState(false)
  const [isPopupOpen, setIsPopupOpen] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const seen = sessionStorage?.getItem('hasSeenExitPopup') === 'true'
      setHasSeenPopup(seen)
    }
  }, [])

  useEffect(() => {
    if (hasSeenPopup || typeof window === 'undefined') return
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0 && !hasSeenPopup) {
        setIsPopupOpen(true)
      }
    }
    const timer = setTimeout(() => {
      document.addEventListener('mouseleave', handleMouseLeave)
    }, 0)

    return () => {
      clearTimeout(timer)
      document.removeEventListener('mouseleave', handleMouseLeave)
    }
  }, [hasSeenPopup])

  const closeModal = () => {
    setIsPopupOpen(false)
    setHasSeenPopup(true);
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('hasSeenExitPopup', 'true')
    }
  }

  const handleDownload = (formData) => {
    const selectedFormat = formData.fields.find(
      (f) => f.name === 'format'
    )?.value
    let downloadPath = ''

    switch (selectedFormat) {
      case 'ebook':
        downloadPath = formats.ebook
        break
      case 'pdf':
        downloadPath = formats.pdf
        break
      case 'slideshow':
        downloadPath = formats.slideshow
        break
      default:
        downloadPath = formats.ebook
    }

    if (downloadPath) {
      customSubmitFunction(downloadPath.replace('/static', ''), ebookData.slug)
      if (typeof window !== 'undefined') {
        sessionStorage.setItem('hasSeenExitPopup', 'true')
      }
      setHasSeenPopup(true)
      setIsPopupOpen(false)
    }
  }

  return (
    <>
      <div
        style={{ opacity: loading ? 0 : 1, minHeight: '100vh' }}
        className="user-layout-container"
        id="user-layout-container"
      >
        {!shouldHidePopup && (<Modal
          isOpen={isPopupOpen}
          onRequestClose={closeModal}
          contentLabel="Contact Form Popup"
          closeTimeoutMS={500}
        >
          <div className={`modal-popup ${isPopupOpen ? 'open' : 'close'}`}>
            <button className="close-button" onClick={closeModal}>
              <svg
                width="44"
                height="44"
                viewBox="0 0 44 44"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="43"
                  height="43"
                  rx="21.5"
                  stroke="black"
                />
                <g clipPath="url(#clip0_543_743)">
                  <path
                    d="M28 16L16 28"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16 16L28 28"
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_543_743">
                    <rect
                      width="24"
                      height="24"
                      fill="white"
                      transform="translate(10 10)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </button>
            <div className="popup-header">
              <img
                src="/images/emoji.webp"
                alt="image"
                className="popup-image"
              />
              <h2 className="popup-title">Wait, Before You Close the Tab…</h2>
            </div>

            <div className="popup-about-content">
              <div className="popup-left-content">
                <h3 className="popup-intro">
                  I built something for you - a framework to help you Become the
                  G.O.A.T of Productivity in Less Than 24 Hours.{' '}
                </h3>
                <span className="list-intro">
                  It's a quick-read guide designed to help you:
                </span>
                <ul className="popup-list">
                  <li>Structure your day with clarity</li>
                  <li>Master time-blocking like a pro</li>
                  <li>Balance work and life without the burnout</li>
                </ul>
                <p className="blue-content">
                  It's free — and it might just change how you work tomorrow.
                </p>
                <div className="ebook-form">
                  <ContactForm
                    fullForm={false}
                    id={`${_.kebabCase(ebookData?.slug)}`}
                    formId={`${_.kebabCase(ebookData?.slug)}`}
                    customSubmitFunction={handleDownload}
                  />
                </div>
              </div>
              <div className="popup-right-content">
                <img
                  className=""
                  src={ebookData?.heroSection?.featuredImage?.image}
                  alt=""
                />
              </div>
            </div>
          </div>
        </Modal>)}
        <FullScreenLoader
          title={`Loading ${getCurrentTheme().name}...`}
          hide={!isChangingTheme}
        />
        <div id="main-page-container-user" className="main-page-container">
          {children}
        </div>
      </div>
      {/* <Footer /> */}
      {/* <FooterSection /> */}
    </>
  )
}
